import _descriptors from "../internals/descriptors";
import _fails from "../internals/fails";
import _documentCreateElement from "../internals/document-create-element";
var exports = {};
var DESCRIPTORS = _descriptors;
var fails = _fails;
var createElement = _documentCreateElement;

// Thanks to IE8 for its funny defineProperty
exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement("div"), "a", {
    get: function () {
      return 7;
    }
  }).a != 7;
});
export default exports;